export interface FilterGroupConfig {
  key: string;
  label: string;
  options: string[];
  value: string;
  onChange: (value: string) => void;
}

interface FilterBarProps {
  groups: FilterGroupConfig[];
}

export default function FilterBar({ groups }: FilterBarProps) {
  return (
    <div className="flex flex-col gap-6">
      {groups.map((group) => (
        <div key={group.key}>
          <h3 className="font-label text-sm font-semibold text-foreground-800">{group.label}</h3>
          <div className="mt-3 flex flex-wrap gap-2">
            {group.options.map((option) => {
              const active = option === group.value;
              return (
                <button
                  key={option}
                  type="button"
                  onClick={() => group.onChange(option)}
                  className={`whitespace-nowrap rounded-full px-3 py-1 font-label text-xs transition-colors cursor-pointer ${
                    active
                      ? 'bg-primary-500 text-background-50'
                      : 'bg-background-100 text-foreground-700 hover:bg-secondary-100'
                  }`}
                >
                  {option}
                </button>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
}